import React from "react";
var Chevron = function (_a) {
    var color = _a.color, direction = _a.direction, className = _a.className;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", className: className },
        React.createElement("path", { fill: color, d: "M15.931 10.9949V13.0027L9.93616 19L8.06885 17.1349L13.2037 12L8.06885 6.86513L9.93616 5L15.931 10.9949Z", transform: getTransformForDirection(direction) })));
};
export default Chevron;
function getTransformForDirection(direction) {
    return direction === "left" ? "rotate(-180, 12, 12)" : "rotate(0)";
}
